module.exports = __webpack_public_path__ + "static/img/201.69d7f8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/productSpring/images/201.png
// module id = 500
// module chunks = 3